import { blue } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    backgroundColor: blue[600],
    color: "#fff",
    padding: spacing(1, 2),
    gap: spacing(1),
    fontSize: "13px",
    // Full-bleed regardless of the parent bar's own horizontal padding
    // (differs between the generic AppBar and ShowBar) — break out to the
    // viewport edge instead of hardcoding a matching negative margin.
    width: "100vw",
    marginLeft: "calc(-50vw + 50%)",
    marginRight: "calc(-50vw + 50%)",
  },
  returnButton: {
    position: "absolute",
    left: spacing(2),
    display: "flex",
    alignItems: "center",
    gap: spacing(0.5),
    color: "#fff",
    fontWeight: 600,
    fontSize: "13px",
    textTransform: "uppercase",
  },
  backIcon: {
    fontSize: "18px",
  },
}));

export default useStyles;
